import { Box, SxProps, Theme, TypographyVariant } from '@mui/material';
import { SystemStyleObject } from '@mui/system';
import { FC, ReactNode } from 'react';

const CIRCLE_SIZE = 24;

type CircleTextProps = {
  children?: ReactNode;
  size?: number;
  variant?: TypographyVariant;
  className?: string;
  sx?: SxProps<Theme>;
};

export const CircleText: FC<CircleTextProps> = ({
  children,
  size = CIRCLE_SIZE,
  variant = 'body1',
  className,
  sx,
}) => (
  <Box
    component="span"
    className={className}
    sx={(theme) => ({
      width: size,
      height: size,
      flexShrink: 0,
      overflow: 'hidden',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      ...theme.typography[variant],
      ...((typeof sx === 'function' ? sx(theme) : (sx ?? {})) as SystemStyleObject),
    })}
  >
    {children}
  </Box>
);
